import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
interface IMarqueeProps {
  items: ReactNode[];
  className?: string;
  speed?: number;
}
const Marquee = props => {
  const $ = _c(13);
  const {
    items,
    className,
    speed: t0
  } = props;
  const speed = t0 === undefined ? 100 : t0;
  let t1;
  if ($[0] !== items) {
    t1 = [...items, ...items];
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const loopItems = t1;
  const t2 = `relative w-full overflow-hidden ${className}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <style>{"\n          @keyframes marquee {\n            from { transform: translateX(0); }\n            to   { transform: translateX(-50%); }\n          }\n        "}</style>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `marquee ${speed}s linear infinite`;
  let t5;
  if ($[3] !== t4) {
    t5 = {
      animation: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== loopItems) {
    t6 = loopItems.map(_temp);
    $[5] = loopItems;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className="flex w-max items-stretch gap-[56px] whitespace-nowrap will-change-transform hover:[animation-play-state:paused] md:gap-24" style={t5}>{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t7) {
    t8 = <div className={t2}>{t3}{t7}</div>;
    $[10] = t2;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default Marquee;
function _temp(child, i) {
  return <div key={i} className="flex-none">{child}</div>;
}